import UserCardsPanel from './UserCardsPanel';

export default UserCardsPanel;
